import React from "react";
import { Form, Input, Row, Col, Card, Typography } from "antd";
import { UserOutlined, HomeOutlined, PhoneOutlined, MailOutlined } from "@ant-design/icons";

const { Title } = Typography;

interface HostTabProps {
  form: any;
}

export const HostTab: React.FC<HostTabProps> = ({ form }) => {
  return (
    <div>
      <Title level={4}>
        <UserOutlined style={{ marginRight: '8px' }} />
        Gastgeberdaten
      </Title>
      
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card title="Persönliche Informationen" size="small">
            <Form.Item
              name={['host', 'name']}
              label="Name"
              rules={[{ required: true, message: 'Bitte geben Sie den Namen ein' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="z.B. Max Mustermann" />
            </Form.Item>

            <Form.Item
              name={['host', 'businessName']}
              label="Betriebsname"
              rules={[{ required: true, message: 'Bitte geben Sie den Betriebsnamen ein' }]}
            >
              <Input prefix={<HomeOutlined />} placeholder="z.B. Musterhof" />
            </Form.Item>

            <Form.Item
              name={['host', 'phone']}
              label="Telefon"
            >
              <Input prefix={<PhoneOutlined />} placeholder="+49 123 456789" />
            </Form.Item>

            <Form.Item
              name={['host', 'email']}
              label="E-Mail"
              rules={[
                { type: 'email', message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein' }
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="info@musterhof.de" />
            </Form.Item>
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Adresse" size="small">
            <Form.Item
              name={['host', 'address', 'street']}
              label="Straße & Hausnummer"
              rules={[{ required: true, message: 'Bitte geben Sie die Straße ein' }]}
            >
              <Input placeholder="z.B. Musterstraße 1" />
            </Form.Item>

            <Row gutter={8}>
              <Col span={12}>
                <Form.Item
                  name={['host', 'address', 'zipCode']}
                  label="PLZ"
                  rules={[{ required: true, message: 'Bitte geben Sie die PLZ ein' }]}
                >
                  <Input placeholder="12345" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name={['host', 'address', 'city']}
                  label="Ort"
                  rules={[{ required: true, message: 'Bitte geben Sie den Ort ein' }]}
                >
                  <Input placeholder="Musterstadt" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              name={['host', 'address', 'country']}
              label="Land"
              rules={[{ required: true, message: 'Bitte geben Sie das Land ein' }]}
            >
              <Input placeholder="Deutschland" />
            </Form.Item>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col span={24}>
          <Card title="Zusätzliche Informationen" size="small">
            <Form.Item
              name={['host', 'description']}
              label="Beschreibung"
            >
              <Input.TextArea 
                rows={4} 
                placeholder="Kurze Beschreibung des Hauses, der Umgebung oder besondere Hinweise..."
              />
            </Form.Item>

            <Form.Item
              name={['host', 'website']}
              label="Website"
            >
              <Input placeholder="https://www.musterhof.de" />
            </Form.Item>

            <Form.Item
              name={['host', 'checkInTimes']}
              label="Check-in Zeiten"
            >
              <Input placeholder="z.B. 15:00 - 18:00 Uhr" />
            </Form.Item>

            <Form.Item
              name={['host', 'checkOutTimes']}
              label="Check-out Zeiten"
            >
              <Input placeholder="z.B. Bis 11:00 Uhr" />
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </div>
  );
}; 